import fetch from "auth/FetchInterceptor";

const authModuleService = {};

authModuleService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/auth-module",
		method: "get",
		params,
	});
};

authModuleService.post = function (data) {
	return fetch({
		url: "/v1/rest/auth-module",
		method: "post",
		data: data,
	});
};

authModuleService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/auth-module/${id}`,
		method: "put",
		data: data,
	});
};

authModuleService.getById = function (id) {
	return fetch({
		url: `/v1/rest/auth-module/${id}`,
		method: "get",
	});
};

export default authModuleService;
